export const CreateValidationObject = (): ValidationFunctionObjectReturnTypes => {
    return {
        error: false,
        message: ''
    }
}
